import React, { useEffect } from 'react';
import { Card } from '@mantine/core';
import classnames from 'classnames';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';

import DataCuts from './DataCuts';
import SurveyDescriptor from './SurveyDescriptor';
import { ISurveyJobProps } from './SurveyJobTypes';

import './SurveyJob.scss';

export default function SurveyJob(props: ISurveyJobProps) {
  const {
    checkedDataCuts,
    disableCheckbox,
    isChecked,
    isSurveyPanel,
    job,
    onCheckDataCut,
    onDataCutListChange,
    setMatchDataLoading,
    surveyJob,
    updateMatchesInState,
    setCheckedDataCuts
  } = props;

  const [{ opacity }, drag, preview] = useDrag(() => ({
    type: 'DATA_CUTS',
    item: { dataCuts: checkedDataCuts },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
      item: monitor.getItem(),
      opacity: monitor.isDragging() ? 0.4 : 1,
    }),
  }), [checkedDataCuts]);

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, []);

  return (
    <Card
      p="xl"
      radius="lg"
      ref={isSurveyPanel ? drag : null}
      shadow={isSurveyPanel ? 'sm' : 'none'}
      style={{ opacity }}
      withBorder={isSurveyPanel}
    >
      <div className={classnames({ 'match-card': !isSurveyPanel })}>
        <SurveyDescriptor
          isSurveyPanel={isSurveyPanel}
          onDataCutListChange={onDataCutListChange}
          surveyJob={surveyJob}
          setCheckedDataCuts={setCheckedDataCuts}
        />
        <DataCuts
          disableCheckbox={disableCheckbox}
          isChecked={isChecked}
          isSurveyPanel={isSurveyPanel}
          job={job}
          onCheckDataCut={onCheckDataCut}
          setMatchDataLoading={setMatchDataLoading}
          surveyJob={surveyJob}
          updateMatchesInState={updateMatchesInState}
        />
      </div>
    </Card>
  );
}

